import React from 'react';
import { Card } from '../ui/primitives/Card';
import { cn } from '../ui/utils/cn';

const sizeStyles = {
  md: {
    tile: 'h-40 w-full',
    image: 'h-full w-full p-6',
    name: 'text-base',
    subtitle: 'text-sm',
    accent: 'h-1',
  },
  footer: {
    tile: 'h-40 w-full',
    image: 'h-full w-full p-6',
    name: 'text-base font-semibold text-gray-800',
    subtitle: 'text-sm text-gray-500',
    accent: 'h-1',
  },
};

const PartnerLogo = ({ partner, size = 'md', variant = 'card', className = '' }) => {
  const styles = sizeStyles[size] ?? sizeStyles.md;
  const isBare = variant === 'bare';

  const content = (
    <>
      {!isBare && partner.accent && styles.accent && (
        <div
          className={cn('absolute top-0 left-0 right-0 rounded-t-2xl', styles.accent)}
          style={{ backgroundColor: partner.accent }}
        />
      )}

      {partner.src ? (
        <img
          src={partner.src}
          alt={partner.alt}
          className={cn(
            'object-contain transition-all duration-300',
            styles.image,
            partner.imageClassName || '',
            !isBare && 'grayscale-[20%] group-hover:grayscale-0'
          )}
        />
      ) : (
        <div className="flex flex-col items-center justify-center px-2 text-center">
          <span className={cn('leading-tight font-semibold text-gray-800', styles.name)}>
            {partner.displayName}
          </span>
          {partner.subtitle && (
            <span className={cn('mt-1 text-gray-500', styles.subtitle)}>{partner.subtitle}</span>
          )}
        </div>
      )}
    </>
  );

  if (isBare) {
    return (
      <div
        className={cn(
          'group relative flex items-center justify-center transition-all duration-300',
          styles.tile,
          'opacity-90 hover:opacity-100 hover:scale-105',
          className
        )}
        title={partner.alt}
      >
        {content}
      </div>
    );
  }

  return (
    <Card
      padding="none"
      hover
      className={cn(
        'group relative flex items-center justify-center overflow-hidden !p-0',
        styles.tile,
        className
      )}
      title={partner.alt}
    >
      {content}
    </Card>
  );
};

export default PartnerLogo;
